angular
    .module('vm.config', [])
    .constant('CONFIG', {
        project: 'nl',
        projectName: 'Nextlove',
        premiumIconColor: 'white',

        defaultDomainSettings: {},
        
        oAuthDefaultRedirectUrl: 'https://m.stage.vm.digisec.info/oauth.html',
        oAuthProviders: {
            facebook: {
                appScope: ['public_profile', 'email', 'user_photos', 'user_birthday', 'user_gender']
            },
            instagram: {
                appScope: ['public_content']
            },
            windowsLive: {
                appScope: ['wl.basic']
            },
            google: {
                appScope: ['email', 'profile']
            }
        },

        // 'ALL' for all domains
        smsVerificationDomains: [],

        profileSections: [
            {
              name: 'appearance',
              translationKey: 'profile.appearance.label',
              icon: 'eye',
              fields: [
                {
                  name: 'height',
                  labelTranslationKey: 'profile.appearance.height'
                },
                {
                  name: 'weight',
                  labelTranslationKey: 'profile.appearance.weight'
                },
                {
                  name: 'eyes',
                  labelTranslationKey: 'profile.appearance.eyes'
                },
                {
                  name: 'hair',
                  labelTranslationKey: 'profile.appearance.hair'
                },
                {
                  name: 'body_type',
                  labelTranslationKey: 'profile.appearance.body_type'
                },
                {
                  name: 'looks',
                  labelTranslationKey: 'profile.appearance.looks'
                },
                {
                  name: 'ethnicity',
                  labelTranslationKey: 'profile.appearance.ethnicity'
                }
              ]
            },
            {
              name: 'background_and_lifestyle',
              translationKey: 'profile.background_and_lifestyle',
              icon: 'na',
              fields: [
                {
                  name: 'relationship_status',
                  labelTranslationKey: 'profile.my_details.relationship_status',
                  enumTranslationKey: 'enumrelationshipstatus'
                },
                {
                  name: 'smoking',
                  labelTranslationKey: 'profile.my_details.smoking'
                },
                {
                  name: 'drinking',
                  labelTranslationKey: 'profile.my_details.drinking'
                },
                {
                  name: 'exercise_habits',
                  labelTranslationKey: 'profile.my_details.exercise_habits',
                  enumTranslationKey: 'enumexercisehabits'
                },
                {
                  name: 'occupation',
                  labelTranslationKey: 'profile.my_details.occupation'
                },
                {
                  name: 'education',
                  labelTranslationKey: 'profile.my_details.education'
                },
                {
                  name: 'living',
                  labelTranslationKey: 'profile.my_details.living'
                },
                {
                  name: 'children_number',
                  labelTranslationKey: 'profile.my_details.children_number',
                  enumTranslationKey: 'enumchildrennumber'
                },
                {
                  name: 'have_children1',
                  labelTranslationKey: 'profile.my_details.have_children1',
                  enumTranslationKey: 'enumhavechildren1'
                },
                {
                  name: 'have_children2',
                  labelTranslationKey: 'profile.my_details.have_children2',
                  enumTranslationKey: 'enumhavechildren2'
                },
                {
                  name: 'religion1',
                  labelTranslationKey: 'profile.my_details.religion1'
                },
                {
                  name: 'diet1',
                  labelTranslationKey: 'profile.my_details.diet1'
                },
                {
                  name: 'pets',
                  labelTranslationKey: 'profile.my_details.pets',
                  multipleUi: true,
                  enumTranslationKey: 'enumpets1',
                },
                {
                  name: 'orientation',
                  labelTranslationKey: 'profile.my_details.orientation'
                },
                {
                  name: 'languages',
                  labelTranslationKey: 'profile.my_details.languages',
                  multipleUi: true,
                }
              ]
            },
            {
              name: 'seeking',
              translationKey: 'search.seeking_for_title',
              icon: 'na',
              fields: [
                {
                  name: 'seeking_location',
                  labelTranslationKey: 'profile.my_details.seeking_location'
                },
                {
                  name: 'seeking_fors',
                  labelTranslationKey: 'common.seeking_for_label',
                  multipleUi: true,
                  enumTranslationKey: 'enumlookingfor',
                },
                {
                  name: 'seeking_relationship_statuses',
                  labelTranslationKey: 'profile.my_details.seeking_relationship_statuses',
                  multipleUi: true,
                  enumTranslationKey: 'enumrelationshipstatus',
                }
              ]
            },
            {
              name: 'more_information',
              translationKey: '',
              icon: 'more',
              fields: [
                {
                  name: 'doing_with_life',
                  labelTranslationKey: 'profile.more_information.doing_with_life',
                  placeholder: '',
                  valid: true,
                },
                {
                  name: 'important_for_you',
                  labelTranslationKey: 'profile.more_information.important_for_you',
                  placeholder: '',
                  valid: true,
                },
                {
                  name: 'parenting_style',
                  labelTranslationKey: 'profile.more_information.parenting_style',
                  placeholder: '',
                  valid: true,
                },
                {
                  name: 'favorites',
                  labelTranslationKey: 'profile.more_information.favorites',
                  placeholder: '',
                  valid: true,
                },
                {
                  name: 'love_five_things',
                  labelTranslationKey: 'profile.more_information.love_five_things',
                  placeholder: '',
                  valid: true,
                },
                {
                  name: 'daydream_about',
                  labelTranslationKey: 'profile.more_information.daydream_about',
                  placeholder: '',
                  valid: true,
                },
                {
                  name: 'typical_weekend',
                  labelTranslationKey: 'profile.more_information.typical_weekend',
                  placeholder: '',
                  valid: true,
                },
                {
                  name: 'private_to_admit',
                  labelTranslationKey: 'profile.more_information.private_to_admit',
                  placeholder: '',
                  valid: true,
                },
                {
                  name: 'perfect_day_idea',
                  labelTranslationKey: 'profile.more_information.perfect_day_idea',
                  placeholder: '',
                  valid: true,
                },
              ]
            },
        ],
    })
;